var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAmex = function SvgIconAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#86868B",
    d: "M41.667 10.232 39.838 12H10.454l-.886-1.89h-1.56L7.202 12H0L5.684 0h13.594l1.367 2.652L21.929 0H40.25l1.566 1.647L43.496 0H52l-6.038 5.982L51.738 12h-8.236zm.007-2.76 2.828 2.81h2.643l-4.04-4.335L47.26 1.71h-2.757l-2.743 2.774L39.2 1.71H28.945v8.57h9.915zM24.792 3.43v6.852h2.197v-8.57h-3.58L20.717 7.45l-2.898-5.74h-3.58v8.314l-3.7-8.314H7.188l-3.955 8.57h2.417l.8-1.953h4.6l.922 1.954h4.443V3.308l3.154 6.974h2.077zm11.566 5.14h-5.216V6.68h5.216V4.97h-5.216V3.43h5.216V1.975l3.87 3.893-3.87 3.907zM7.187 6.602l1.616-3.479 1.495 3.48z"
  })));
};
export default SvgIconAmex;